import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c('h3',[_vm._v(_vm._s(_vm.$tt('customChangePasswordSuccess')))]),_c('br'),_c(VBtn,{staticClass:"white--text text-none",attrs:{"to":{ name: 'UserSettings' },"color":"primary"}},[_vm._v("\n    "+_vm._s(_vm.$tt('customUserSettings'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }